import Vue from 'vue'
import VueRouter from 'vue-router'
import { getToken } from '@/utils/auth'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    hidden: true
  },
  {
    path: '/',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: { title: '首页', icon: 'el-icon-s-home' }
      }
    ]
  },
  {
    path: '/file',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/file/file',
    children: [
      {
        path: 'file',
        name: 'file',
        component: () => import('@/views/file/file.vue'),
        meta: { title: '知识库', icon: 'el-icon-collection' }
      }
    ]
  },
  {
    path: '/orderRecord',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/orderRecord/orderRecord',
    children: [
      {
        path: 'orderRecord',
        name: 'orderRecord',
        component: () => import('@/views/orderRecord/orderRecord.vue'),
        meta: { title: '订单记录', icon: 'el-icon-s-home' }
      }
    ]
  },
  {
    path: '/user',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/user/list',
    children: [
      {
        path: 'list',
        name: 'list',
        component: () => import('@/views/user/list.vue'),
        meta: { title: '用户管理', icon: 'el-icon-s-home' }
      },
      {
        path: 'package',
        name: 'Package',
        component: () => import('@/views/user/package.vue'),
        meta: { title: '套餐管理', icon: 'el-icon-s-home' }
      }
      ,{
        path: 'order',
        name: 'order',
        component: () => import('@/views/user/order.vue'),
        meta: { title: '订单管理', icon: 'el-icon-s-home' }
      }
    ]
  },

  {
    path: '/service',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/service/workbench',
    meta: { title: '客服中心', icon: 'el-icon-service' },
    children: [
      {
        path: 'workbench',
        name: 'ServiceWorkbench',
        component: () => import('@/views/service/workbench.vue'),
        meta: { title: '会话工作台', icon: 'el-icon-chat-dot-round' }
      }
    ]
  },

  {
    path: '/system',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/system/admin',
    meta: { title: '系统管理', icon: 'el-icon-s-tools' },
    children: [
      {
        path: 'admin',
        name: 'Admin',
        component: () => import('@/views/admin/index.vue'),
        meta: { title: '管理员列表', icon: 'el-icon-user' }
      },
      {
        path: 'role',
        name: 'Role',
        component: () => import('@/views/role/index.vue'),
        meta: { title: '角色管理', icon: 'el-icon-s-custom' }
      },
      {
        path: 'menu',
        name: 'Menu',
        component: () => import('@/views/menu/index.vue'),
        meta: { title: '菜单管理', icon: 'el-icon-menu' }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const token = getToken()
  if (to.path === '/login') {
    next()
  } else {
    if (!token) {
      next('/login')
    } else {
      next()
    }
  }
})

export default router
